// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tlm-checkout__content{padding:0}@media screen and (min-width:600px){.tlm-checkout__content{padding:12px}}.tlm-checkout--family .tlm-checkout-panel .v-expansion-panel-header--active{background-color:var(--v-tertiary-base);color:#fff}.tlm-checkout--family .tlm-checkout-panel .v-expansion-panel-header--active .tlm-checkout-panel__counter{color:#fff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
